"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("../../config/types");
const offchainPoolToken_1 = __importDefault(require("../offchainPoolToken"));
class OffchainCollateral extends offchainPoolToken_1.default {
    constructor(lendingPool) {
        super();
        this.getOffchain = () => this.lendingPool.getOffchain();
        this.getLendingPool = () => this.lendingPool;
        // shortcuts
        this.getBorrowableA = () => this.lendingPool.getPoolToken(types_1.PoolTokenType.BorrowableA);
        this.getBorrowableB = () => this.lendingPool.getPoolToken(types_1.PoolTokenType.BorrowableB);
        this.lendingPool = lendingPool;
    }
    getPoolTokenData() {
        return __awaiter(this, void 0, void 0, function* () {
            const lendingPoolData = yield this.lendingPool.getLendingPoolData();
            return lendingPoolData[types_1.PoolTokenType.Collateral];
        });
    }
    getName() {
        return __awaiter(this, void 0, void 0, function* () {
            const nameA = yield this.getBorrowableA().getName();
            const nameB = yield this.getBorrowableB().getName();
            return nameA + '-' + nameB + ' LP';
        });
    }
    getSymbol() {
        return __awaiter(this, void 0, void 0, function* () {
            const symbolA = yield this.getBorrowableA().getSymbol();
            const symbolB = yield this.getBorrowableB().getSymbol();
            return symbolA + '-' + symbolB;
        });
    }
    getDecimals() {
        return __awaiter(this, void 0, void 0, function* () {
            return 18;
        });
    }
    getUnderlyingAddress() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.lendingPool.getPairAddress();
        });
    }
    // Token price getters
    getTokenPriceFast(fallback = true) {
        const _super = Object.create(null, {
            getTokenPriceFast: { get: () => super.getTokenPriceFast }
        });
        return __awaiter(this, void 0, void 0, function* () {
            let tokenPrice = yield this.lendingPool.getCollateralPrice(false);
            if (tokenPrice > 0)
                return tokenPrice;
            return _super.getTokenPriceFast.call(this, fallback);
        });
    }
    getTokenPriceAccurate() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.lendingPool.getCollateralPrice(false);
        });
    }
}
exports.default = OffchainCollateral;
